<style scoped>
  #reconciliationResults{
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }

  #reconciliationResults small{
    text-transform: uppercase;
    font-size: 0.6em;
  }

  #reconciliationResults strong{
    /* color: #555; */
    font-size: 1.1em;
    letter-spacing: 0.06em;
    font-weight: normal;
    text-transform: uppercase;
    display: block;
    margin-bottom: 0.2em;
  }

  #reconciliationResults > div:nth-child(-n + 2){
    margin-bottom: 1.2em;
  }

  #reconciliationResults > div{
    padding: 2em;
    width: 49%;
    border: 1px solid #ddd;
  }
</style>

<template>
  <div>
    <div class="row animated fadeIn">
      <div style="padding: 0 1rem; margin-bottom: 2em">
        <month-picker 
          v-model="selectedMonth"
          :max="new Date()" />
      </div>

      <div class="col col-sm-12" style="max-width: 800px">
        <div class="card">
          <div class="card-header d-flex align-items-center justify-content-between">
            <h5 class="mb-0">Reconcilliation statement for <strong>{{ monthString }}</strong></h5>
          </div>

          <div class="card-body text-center" v-if="fetchingReconStatement || !reconStatement">
            <div v-if="fetchingReconStatement">
              <Loader :size="90" />
              <h4>Genereting statment for {{ monthString }}</h4>
              <br/>
            </div>

            <div class="text-center" v-else-if="reconStatement === null">
              Failed to fetch savings data.
            </div>

            <div class="text-center" v-else-if="!reconStatement">
              No reconcilliation data found for {{ monthString }}
            </div>
          </div>

          <template v-else>
            <div class="card-body pb-0">
              <b-alert show :variant="reconSummary.type" class="mt-0 mb-0 d-inline-block" style="font-size: 1.35em">
                <strong>
                  {{reconSummary.type === "success" ? "Success" : "Note"}}:
                </strong>
                {{ reconSummary.message }}
              </b-alert>  
            </div>
            <div id="reconciliationResults" class="card-body">
              <div>
                <strong>Bank Balance</strong>
                <h1>
                  <small>Tshs.</small> {{ parseInt(reconStatement.bankSum).toLocaleString() }}
                </h1>
              </div>

              <div>
                <strong>Mobile Balance</strong>
                <h1>
                  <small>Tshs.</small> {{ parseInt(reconStatement.mobileSum).toLocaleString() }}
                </h1>
              </div>

              <div>
                <strong>Finlink Balance</strong>
                <h1>
                  <small>Tshs.</small> {{ parseInt(reconStatement.finlinkSum).toLocaleString() }}
                </h1>
              </div>

              <div>
                <strong>Variation</strong>
                <h1>
                  <small>Tshs.</small> {{ parseInt(reconStatement.variation).toLocaleString() }}
                </h1>
              </div>
            </div>
          </template>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import MonthPicker from '../components/MonthPicker';
  const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

  export default {
    name: 'Reconcilliation',
    mounted(){
      this.fetchReconStatement();
    },
    data: function(){
      return {
        selectedMonth: {
          year: new Date().getFullYear(),
          month: new Date().getMonth()
        }
      };
    },
    methods: {
      fetchReconStatement(){
        this.$store.dispatch('getReconStatement', {year: this.year, month: this.month + 1});
      }
    },
    watch: {
      selectedMonth: function(newVal){
        this.fetchReconStatement();
      }
    },
    computed: {
      ...mapState(['reconStatement', 'fetchingReconStatement']),
      month: function(){
        if(!this.selectedMonth || this.selectedMonth.month === undefined)
          return null;

        return this.selectedMonth.month;
      },
      year: function(){
        if(!this.selectedMonth || !this.selectedMonth.year)
          return null;

        return this.selectedMonth.year;
      },
      monthString: function(){
        return `${months[this.month]} ${this.year}`;
      },
      reconSummary: function(){
        if(this.fetchingReconStatement || !this.reconStatement)
          return null;

        if(this.reconStatement.variation < 0){
          return {
            type: "danger",
            message: "It looks like either some money is missing from the bank or collection accounts or there was an error during recording some transactions."
          }
        }
        else if(this.reconStatement.variation > 0){
          return {
            type: "danger",
            message: "It looks like either there was an error during recording bank / mobile balances or some transactions were not recorded."
          }
        }
        else if(this.reconStatement.variation === 0){
          return {
            type: "success",
            message: `Your records for ${months[this.selectedMonth.month]} ${this.selectedMonth.year} reconcile perfectly.`
          }
        }
      }
    },
    components: {
      MonthPicker
    }
  }
</script>
